import { render, staticRenderFns } from "./MenuLogged.vue?vue&type=template&id=c366ff52"
import script from "./MenuLogged.vue?vue&type=script&lang=js"
export * from "./MenuLogged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports